"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureBang = exports.FeatureBangProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/* istanbul ignore file */

var FeatureBangContext = /*#__PURE__*/(0, _react.createContext)();
var FeatureBangProvider = exports.FeatureBangProvider = function FeatureBangProvider(_ref) {
  var children = _ref.children,
    config = _ref.config;
  return /*#__PURE__*/_react["default"].createElement(FeatureBangContext.Provider, {
    value: {
      config: config
    }
  }, children);
};
var useFeatureBang = exports.useFeatureBang = function useFeatureBang() {
  var config = (0, _react.useContext)(FeatureBangContext);
  if (!config) {
    throw new Error("Can not use useFeatureBang outside of a FeatureBang Provider");
  }
  return config;
};